import { render, staticRenderFns } from "./cModalVouSerie.vue?vue&type=template&id=32532779"
import script from "./cModalVouSerie.vue?vue&type=script&lang=js"
export * from "./cModalVouSerie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports